import styled from 'styled-components';

export const ShiftInfoContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  display: flex;
  margin-bottom: 10px;
  padding-bottom: 20px;
`;
